import React from 'react';
import MetaTitle from '../../components/MetaTitle';
import useSignalR from '../../hooks/useSignalR';
import useQuery from '../../hooks/useQuery';
// import Map from '../../components/Map';

import { useDispatch } from 'react-redux';
import { refreshToken } from '../../store/user';
const Map = React.lazy(() => import('../../components/Map'));

export default function Monitor() {
  const param = useQuery().get('document');
  const dispatch = useDispatch();

  const handleError = (err) => {
    if (err?.status === 401 && !err?.config.url.includes('refresh-login')) {
      dispatch(refreshToken());
    }
  };

  const [state, setState] = useSignalR({
    param: param,
    path: 'lastPosition',
    initialState: [],
    data: async (data) => {
      try {
        const position = data.map(
          ({
            id,
            licensePlate,
            lastLatitude,
            lastLongititude,
            warehouses,
            shippingCode,
          }) => ({
            id: id,
            code: shippingCode,
            name: licensePlate,
            latLngFinal: warehouses,
            lat: +lastLatitude,
            lng: +lastLongititude,
          }),
        );
        setState(position);
      } catch ({ response: err }) {
        handleError(err);
      }
    },
  });

  return (
    <>
      <React.Suspense fallback={<div></div>}>
        <MetaTitle title="Mapa" />
        <Map
          style={{
            height: 'calc(100vh - 81px)',
            width: '100%',
            marginTop: '0',
            gap: '15px',
          }}
          data={state}
        />
      </React.Suspense>
    </>
  );
}
